<template>
  <div v-if="image" class="relative overflow-hidden">
    <CraftAsset
      :asset="image"
      :autoplay="true"
      sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
      :width="420"
      :ratio="5 / 4"
      crop="fill"
      class="block md:hidden absolute inset-0 z-0 max-w-none object-cover w-full h-full"
    />
    <CraftAsset
      :asset="image"
      :autoplay="true"
      sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
      :width="1440"
      :ratio="21 / 9"
      crop="fill"
      class="md:block hidden absolute inset-0 z-0 w-full h-full max-w-none object-cover"
    />
    <div class="absolute inset-0">
      <slot />
    </div>
  </div>
</template>

<script>
import CraftAsset from '@/components/common/CraftAsset';
import FixedAspect from '@/components/common/FixedAspect';

export default defineNuxtComponent({
  components: {
    CraftAsset,
    FixedAspect,
  },
  props: {
    image: {
      type: Object,
      default: () => null,
    },
  },
});
</script>
